<app-drawer-base [opened]="(isShowingNotifications$ | async) ?? false" (closed)="close()">
  <div class="notification-drawer">
    <h2>{{ 'header.notifications.title' | translate }}</h2>

    <div class="actions">
      <button mat-stroked-button color="primary" (click)="markAllAsRead()">
        <mat-icon>visibility</mat-icon>
        {{ 'header.notifications.mark-all-as-read' | translate }}
      </button>
    </div>

    <div class="notification-container">
      <div *ngFor="let notification of notifications$ | async" class="notification">
        <span *ngIf="notification.parentName && notification.parentLink !== ''" class="notification-parent">
          <a href="{{ notification.parentLink }}" target="_blank">
            {{ notification.parentName }}
          </a>
        </span>
        <h3 class="notification-title">{{ getNotificationTriggeredByName(notification) + notification.title }}</h3>
        <p class="notification-text">{{ notification.text }}</p>
        <span class="notification-link">
          <ng-container *ngIf="notification.folderName && notification.folderLink !== ''">
            <a href="{{ notification.folderLink }}" target="_blank">
              {{ notification.folderName }}
            </a>
            <span>&nbsp;/&nbsp;</span>
          </ng-container>
          <a *ngIf="notification.directLink" [href]="notification.directLink" (click)="markAsRead(notification)" target="_blank">
            {{ notification.itemName }}
          </a>
          <a *ngIf="!notification.directLink" [routerLink]="getRouterLink(notification)" (click)="markAsRead(notification)">
            {{ notification.itemName }}
          </a>
        </span>
        <small class="notification-time">{{ getNotificationTime(notification) }}</small>
        <button
          mat-icon-button
          color="primary"
          *ngIf="!notification.isRead"
          (click)="markAsRead(notification)"
          [matTooltip]="'header.notifications.mark-as-read' | translate"
          matTooltipPosition="left"
          [attr.aria-label]="'header.notifications.mark-as-read' | translate"
          class="notification-delete"
        >
          <mat-icon svgIcon="circle_filled" />
        </button>
        <button
          mat-icon-button
          *ngIf="notification.isRead"
          (click)="markAsUnread(notification)"
          [matTooltip]="'header.notifications.mark-as-unread' | translate"
          matTooltipPosition="left"
          [attr.aria-label]="'header.notifications.mark-as-unread' | translate"
          class="notification-delete"
        >
          <mat-icon svgIcon="circle_empty" />
        </button>
      </div>
    </div>
  </div>
</app-drawer-base>
